import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";
import {DCRoadWinCap} from "./DCRoadWinCap";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {DevilsCrossRoadGameAssets} from "../DevilsCrossRoadGameAssets";
import {DevilsCrossRoadLayers, Layers} from "./DevilsCrossRoadLayers";
import {IntroButton} from "./IntroButton";
import {DCRoadIntroScatterBox} from "./DCRoadIntroScatterBox";


export class TransitionScreenView extends PIXI.Container {

    protected button:IntroButton;
    private clickCallback?:Function;
    private introSign:PIXI.Sprite = new PIXI.Sprite();
    public maxCap:DCRoadWinCap = new DCRoadWinCap();
    private _bonusIntroSpine:PIXI.spine.Spine;
    private _bonusOutroSpine:PIXI.spine.Spine;
    private _winCapActive:boolean = false;
    private _bonusOutroTotalWinAmount:BitmapCountUp;
    private _scatterBox: DCRoadIntroScatterBox = new DCRoadIntroScatterBox();

    private _layer:StageLayer;

    constructor(name?:string) {
        super();
        this.name = name ? name : "TransitionScreenView";
        this._layer = DevilsCrossRoadLayers.getLayer(Layers.SCREENS)!;
        this.init();
    }

    protected init() {
        this.button = new IntroButton();
        this.button.addClickCallback(() => this.onButtonClick());

        this.button.position.set(360, 610);
        this.button.pivot.set(this.button.width * 0.5, this.button.height * 0.5);
        this.button.enable(false);
        this.button.alpha = 0;

        this._bonusIntroSpine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("bonusIntro"));
        this._bonusIntroSpine.position.set(360, 360);
        this._bonusIntroSpine.visible = false;
        this.addChild(this._bonusIntroSpine);

        this._bonusOutroSpine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("bonusOutro"));
        this._bonusOutroSpine.position.set(360, 360);
        this._bonusOutroSpine.visible = false;
        this.addChild(this._bonusOutroSpine);


        const style = {
            fontName : DevilsCrossRoadGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 100,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        this._bonusOutroTotalWinAmount = new BitmapCountUp(style);
        this._bonusOutroTotalWinAmount.shrinkSize = true;
        this._bonusOutroTotalWinAmount.visible = false;
        this._bonusOutroTotalWinAmount.position.set(360, 400);
        this.addChild(this._bonusOutroTotalWinAmount);

        this._layer.addChild(this.maxCap);
        this.addChild(this.introSign);
        this.addChild(this._scatterBox);
        this.addChild(this.button);
        this.visible = false;
        this._layer.addChild(this);
    }

    onResize():void {
        const centerBottom = (NolimitApplication.screenBounds.bottom - 610) * 0.5 + 610;
        this.button.position.set(360, this._winCapActive ? (NolimitApplication.isLandscape? 600: centerBottom) : 560);

        // if() {
        //     this.button.position.set(360, this._winCapActive ? 600 : 540);
        // } else {
        //     this.button.position.set(360, this._winCapActive ?  : NolimitApplication.screenBounds.bottom - 460);
        // }


    }

    private onButtonClick() {
        this.button.enable(false);
        if(this.clickCallback == undefined) {
            throw new Error("No button click callback");
        }
        this.clickCallback();
        DevilsCrossRoadSound.soundPlayer.playTrack({name : DevilsCrossRoadSound.CONTINUE_BUTTON});
        gsap.to(this.button, {duration : 0.2, alpha : 0});
        delete this.clickCallback;
    }

    public enableButton(cb:Function):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.clickCallback = cb;
            this.button.enable(true);
        });
        tl.add(gsap.to(this.button, {duration : 0.2, alpha : 1}));
        return tl;
    }

    public showIntro():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        // let stringName:string=DevilsCrossRoad.model.data.nextMode===DevilsCrossRoadGameMode.FREESPIN?"fs_intro":"sfs_intro";
        let duration:number = this._bonusIntroSpine.spineData.findAnimation("fs_intro").duration;
        this.button.labelChange("SIGN HERE");
        this.button.borderTintChange(0x000000, 1);
        this.resetSpine(this._bonusIntroSpine);
        DevilsCrossRoad.freespinReelAreaView.reels.forEach((reels) => {
            reels.forEach((reel) => {
                reel.model.unsetStickyReel();
            });
        });

        if(DevilsCrossRoad.model.data.mode !== DevilsCrossRoadGameMode.FREESPIN) {
            DevilsCrossRoad.freespinReelAreaView.reInitReel();
        }

        tl.add(() => {
            this.onResize();

            DevilsCrossRoad.freespinReelAreaView.resetEmptyReels(DevilsCrossRoad.model.data.stickyCoins, DevilsCrossRoad.model.data.stickyCoinsValuesBeforeFeature, true);
            DevilsCrossRoad.freespinReelAreaView.setReelsWithData(DevilsCrossRoad.model.data.stickyCoins, DevilsCrossRoad.model.data.stickyCoinsValuesBeforeFeature);
            this.visible = true;
        });

        tl.add([
            () => {

                DevilsCrossRoad.freespinReelAreaView.setReelsWithData(DevilsCrossRoad.model.data.stickyCoins,
                    (DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.SUPER_FREESPIN)? DevilsCrossRoad.model.data.stickyCoinsValues
                        : DevilsCrossRoad.model.data.stickyCoinsValuesBeforeFeature);
                DevilsCrossRoad.totalWinCountUp.remove();
                DevilsCrossRoad.bigWinCountUp.remove();
                DevilsCrossRoad.reelFrameView.switchReelFrame(DevilsCrossRoadGameMode.FREESPIN);
                DevilsCrossRoad.freespinReelAreaView.switchReelMode(DevilsCrossRoadGameMode.FREESPIN);
                DevilsCrossRoad.backgroundElements.setMode(DevilsCrossRoadGameMode.FREESPIN);
                DevilsCrossRoad.freespinUnlockAreas.show();
                DevilsCrossRoad.freespinReelAreaView.initReels();
                DevilsCrossRoad.freespinMpView.show();
                DevilsCrossRoad.model.initData.collectMeter;
                if (DevilsCrossRoad.model.data.wasFeatureBuy && DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.SUPER_FREESPIN) {
                    DevilsCrossRoad.freespinCollectorView.show(4);
                }
                else {
                    DevilsCrossRoad.freespinCollectorView.show(DevilsCrossRoad.model.data.collectMeter);
                }
            },

        ], "<");
        tl.add(() => {
            this._bonusIntroSpine.visible = true;
            this._bonusIntroSpine.state.setAnimation(0, "fs_intro", false);
        }, ">");
        tl.add(() => {
            this._scatterBox.showScatterBox(DevilsCrossRoad.model.data.collectMeter);
            this._bonusIntroSpine.state.setAnimation(0, "fs_intro_idle", true);
        }, `>${duration}`);

        return tl;
    }

    public hideIntro():gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            this._scatterBox.hideScatterBox();
            this._bonusIntroSpine.state.setAnimation(0, "fs_intro_remove", false);
        });
        tl.add(() => {
            this._bonusIntroSpine.visible = false;
        }, `>${this._bonusIntroSpine.spineData.findAnimation("fs_intro_remove").duration}`);
        return tl;
    }

    public showOutro(amount:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        this.button.labelChange("SIGN HERE");
        this.button.borderTintChange(0x000000, 1);
        this.resetSpine(this._bonusOutroSpine);
        tl.add(() => {
            DevilsCrossRoad.totalWinCountUp.remove();
            DevilsCrossRoad.bigWinCountUp.remove();
            this.onResize();
            this.visible = true;
        },0);
        tl.add(() => {
            this._bonusOutroSpine.visible = true;
            if (BelowStakeWinRestriction.isWinBelowStake()) {
                this._bonusOutroSpine.state.setAnimation(0, "fs_outro_nowin", false);

            } else {
                this._bonusOutroSpine.state.setAnimation(0, "fs_outro", false);
            }
        }, ">");
        tl.add(() => {
            this._bonusOutroTotalWinAmount.visible = true;
            this._bonusOutroTotalWinAmount.maxTextWidth = 400;
            if(BelowStakeWinRestriction.isWinBelowStake()) {
                this._bonusOutroSpine.state.setAnimation(0, "fs_outro_idle_nowin", true);
                this._bonusOutroTotalWinAmount.getCountUpAnimation(0, amount, 0);
            } else {
                this._bonusOutroSpine.state.setAnimation(0, "fs_outro_idle", true);
                this._bonusOutroTotalWinAmount.getCountUpAnimation(0, amount, 0.5);
                if(amount > 0){
                    DevilsCrossRoadSound.soundPlayer.playTrack({name:DevilsCrossRoadSound.FS_ENDS_COUNTUP});
                }
            }
        }, `>${this._bonusOutroSpine.spineData.findAnimation("fs_outro").duration}`);
        tl.to(this,{duration:0.5});
        tl.add(()=>{
            if (DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_ENDS_COUNTUP)?.isPlaying) {
                DevilsCrossRoadSound.fadeAndStopSound({name:DevilsCrossRoadSound.FS_ENDS_COUNTUP, to:0,duration:50});
            }
            DevilsCrossRoadSound.switchMusic({name:DevilsCrossRoadSound.getMusicNameByMode(DevilsCrossRoad.model.gameData.nextMode)});

        },">");
        let belowWinStakeRegardlessOfJur:boolean = BelowStakeWinRestriction.isWinBelowStakeRegardlessOfJur();

        if(!belowWinStakeRegardlessOfJur) {
            tl.add(() => {
                DevilsCrossRoadSound.soundPlayer.playTrack({name : DevilsCrossRoadSound.BONUS_ENDS_GOOD});
            });
        } else {
            if(!BelowStakeWinRestriction.isWinBelowStake()) {
                tl.add(() => {
                    DevilsCrossRoadSound.soundPlayer.playTrack({name : DevilsCrossRoadSound.BONUS_ENDS_BAD});
                });
            }
        }

        return tl;
    }

    public hideOutro():gsap.core.Timeline {
        const tl = gsap.timeline();

        if(!this._winCapActive) {
            tl.add(() => {
                this._bonusOutroTotalWinAmount.visible = false;
                if(BelowStakeWinRestriction.isWinBelowStake()) {
                    this._bonusOutroSpine.state.setAnimation(0, "fs_outro_remove_nowin", false);
                } else {
                    this._bonusOutroSpine.state.setAnimation(0, "fs_outro_remove", false);
                }
                DevilsCrossRoad.endBonusView.reset();
            });
            tl.add(() => {
                this._bonusOutroSpine.visible = false;
            }, `>${this._bonusOutroSpine.spineData.findAnimation("fs_outro_remove_nowin").duration}`);
        }
        tl.add(() => {
                if(DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.NORMAL) {
                    DevilsCrossRoad.reelFrameView.switchReelFrame(DevilsCrossRoadGameMode.NORMAL);
                    DevilsCrossRoad.freespinReelAreaView.switchReelMode(DevilsCrossRoadGameMode.NORMAL);
                    DevilsCrossRoad.backgroundElements.setMode(DevilsCrossRoadGameMode.NORMAL);
                    DevilsCrossRoad.freespinMpView.hide();
                    DevilsCrossRoad.freespinCollectorView.hide();
                    DevilsCrossRoad.freespinUnlockAreas.hide();
                    //DevilsCrossRoad.freespinUnlockAreas.resetEyeAnimations();
                    BelowStakeWinRestriction.reset();
                    this._winCapActive = false;
                    this._bonusOutroTotalWinAmount.text = "0";
                }
            }
            , "<");

        return tl;
    }

    public showMaxCap():gsap.core.Timeline {
        const tl:gsap.core.Timeline = new gsap.core.Timeline();
        this.button.labelChange("CONTINUE");
        this.button.borderTintChange(0xffffff, 0);
        tl.add(() => {
            this.visible = true;
            this._winCapActive = true;
            this.onResize();
        });
        tl.add(this.maxCap.showWinCap());
        return tl;
    }


    public hideMaxCap():gsap.core.Timeline {
        const tl:gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this.visible = true;
            this.onResize();
        });
        tl.add(this.maxCap.hideWinCap());
        return tl;
    }

    private resetSpine(spineToReset:PIXI.spine.Spine):void {
        spineToReset.state.clearTracks();
        spineToReset.skeleton.setToSetupPose();
        spineToReset.skeleton.setSlotsToSetupPose();
    }
}